import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { inject } from '@angular/core';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth-interceptor';
import { errorInterceptor } from './core/error/error-interceptor';
import { ChunkAwareErrorHandler, NewVersionNotice } from './core/errors/new-version-notice';
import { isChunkLoadFailure } from './core/errors/chunk-load-recovery';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      // A failed lazy route is reported here rather than thrown, so the global
      // handler alone would miss the most common way this happens: clicking a
      // menu item after a deploy.
      withNavigationErrorHandler(e => {
        if (isChunkLoadFailure(e.error)) inject(NewVersionNotice).markStale();
      })
    ),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    // And here for the rest: a lazy import inside an already-loaded route
    // arrives as an unhandled rejection, not as a navigation error.
    { provide: ErrorHandler, useClass: ChunkAwareErrorHandler },
  ]
};
